import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AnimalCreationComponent } from './animal-creation/animal-creation.component';
import { VaccineCreationComponent } from './vaccine-creation/vaccine-creation.component';
import { VaccineScheduleComponent } from './vaccine-schedule/vaccine-schedule.component';
import { VaccineConfigurationComponent } from './vaccine-configuration/vaccine-configuration.component';

const routes: Routes = [
  { path: 'animalreg', component: AnimalCreationComponent },
  { path: 'vaccinereg', component: VaccineCreationComponent },
  { path: 'vacnsched', component: VaccineScheduleComponent },
  { path: 'vacnconfig', component: VaccineConfigurationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VaccinationMasterRoutingModule { }
